module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!!_vm.r) ? _c('gmap-info-window', {
    attrs: {
      "options": _vm.infoWindowOptions,
      "position": _vm.r.position
    },
    on: {
      "closeclick": function($event) {
        _vm.$bus.$emit('toggleMarkerInfo')
      }
    }
  }, [_c('div', {
    staticClass: "rp-iwin"
  }, [(!!_vm.r.name) ? _c('h3', [_vm._v(_vm._s(_vm.r.name))]) : _vm._e(), _vm._v(" "), (!!_vm.r.formatted_address) ? _c('p', {
    staticClass: "rp-iwin-param"
  }, [_c('span', {
    staticClass: "rp-iwin-param-field"
  }, [_vm._v("Address: ")]), _vm._v(" "), _c('span', {
    staticClass: "rp-iwin-param-value"
  }, [_vm._v(_vm._s(_vm.r.formatted_address))])]) : _vm._e(), _vm._v(" "), (!!_vm.r.international_phone_number) ? _c('p', {
    staticClass: "rp-iwin-param"
  }, [_c('span', {
    staticClass: "rp-iwin-param-field"
  }, [_vm._v("Phone number: ")]), _vm._v(" "), _c('span', {
    staticClass: "rp-iwin-param-value"
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.r.international_phone_number
    }
  }, [_vm._v(_vm._s(_vm.r.international_phone_number))])])]) : _vm._e(), _vm._v(" "), (_vm.r.types) ? _c('p', {
    staticClass: "rp-iwin-param"
  }, [_c('span', {
    staticClass: "rp-iwin-param-field"
  }, [_vm._v("Tags: ")]), _vm._v(" "), _c('span', {
    staticClass: "rp-iwin-param-value"
  }, [_vm._v(_vm._s(_vm._f("commedArray")(_vm.r.types)))])]) : _vm._e(), _vm._v(" "), (_vm.r.position) ? _c('p', {
    staticClass: "rp-iwin-param"
  }, [_c('span', {
    staticClass: "rp-iwin-param-field"
  }, [_vm._v("Location: ")]), _vm._v(" "), _c('span', {
    staticClass: "rp-iwin-param-value"
  }, [_vm._v(_vm._s(_vm._f("latlng")(_vm.r.position)))])]) : _vm._e(), _vm._v(" "), (_vm.thumbs) ? _c('div', {
    staticClass: "rp-iwin-photos clearfix"
  }, _vm._l((_vm.thumbs), function(p) {
    return _c('a', {
      staticClass: "rp-iwin-photo",
      style: ({
        backgroundImage: 'url(' + p.thumb + ')'
      }),
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {}
      }
    }, [_c('img', {
      staticClass: "rp-iwin-photo-img",
      attrs: {
        "src": p.thumb
      }
    })])
  })) : _vm._e(), _vm._v(" "), (!_vm.editing && !!_vm.r.note) ? _c('div', {
    staticClass: "rp-iwin-note"
  }, [_c('div', {
    staticClass: "alert alert-info",
    domProps: {
      "innerHTML": _vm._s(_vm.compiledNote)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "rp-iwin-note-editor"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note),
      expression: "note"
    }],
    ref: "note",
    staticClass: "form-control",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.editing) ? _c('p', {
    staticClass: "rp-iwin-actions"
  }, [_c('a', {
    staticClass: "rp-iwin-action btn btn-primary btn-sm",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.edit()
      }
    }
  }, [_c('span', {
    staticClass: "icon-pencil"
  }), _vm._v(" " + _vm._s(_vm.r.note ? "Edit Note" : "Add Note"))]), _vm._v(" "), _c('a', {
    staticClass: "rp-iwin-action btn btn-default btn-sm",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.remove()
      }
    }
  }, [_c('span', {
    staticClass: "icon-times"
  }), _vm._v(" Delete")]), _vm._v(" "), (!!_vm.r.url) ? _c('a', {
    staticClass: "rp-iwin-action",
    attrs: {
      "href": _vm.r.url,
      "target": "_blank"
    }
  }, [_vm._v("View on Google Maps")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('p', {
    staticClass: "rp-iwin-actions"
  }, [_c('a', {
    staticClass: "rp-iwin-action btn btn-primary btn-sm",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_c('span', {
    staticClass: "icon-checkmark"
  }), _vm._v(" Save")]), _vm._v(" "), _c('a', {
    staticClass: "rp-iwin-action btn btn-default btn-sm",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_c('span', {
    staticClass: "icon-times"
  }), _vm._v(" Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "rp-iwin-action",
    attrs: {
      "href": "https://en.wikipedia.org/wiki/Markdown",
      "target": "_blank"
    }
  }, [_vm._v("Markdown supported")])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b35eae6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/MarkerInfo.vue
// module id = 477
// module chunks = 0